"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmissionStatus = void 0;
var SubmissionStatus;
(function (SubmissionStatus) {
    SubmissionStatus["Draft"] = "Draft";
    SubmissionStatus["Submitted"] = "Submitted";
    SubmissionStatus["Cancelled"] = "Cancelled";
})(SubmissionStatus = exports.SubmissionStatus || (exports.SubmissionStatus = {}));
//# sourceMappingURL=SubmissionStatus.js.map